<template>
    <v-row style="padding-top: 7%;" no-gutters>
      <v-col md="6">
        <v-img :src="require('../assets/img-01.jpg')" width="100%"/>
      </v-col>
      <v-col md="6">
        <v-container class="ml-10 text-left" fill-height>
          <v-spacer/>
          <body-1 class="body">
            Proveemos soporte a nuestros clientes en sus procesos de toma de decisiones operacionales, comerciales y de inversión bajo incertidumbre, entregando propuestas de valor mediante modelos matemáticos de alta complejidad.
          </body-1>
          <body-1 class="body">
            Desarrollamos nuestros propios modelos de optimización y simulación matemática, lo que nos otorga gran flexibilidad para adecuar nuestros servicios a los requerimientos de cada cliente.
          </body-1>
          <v-spacer/>
        </v-container>
      </v-col>
    </v-row>
</template>

<script>
export default {
  name: 'app',
}
</script>

<style>

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.body {
  color: #161c2d;
}

</style>



// WEBPACK FOOTER //
// src/components/CoverLarge.vue